bovoApp.controller('PalletteController', ['$scope', 'Pallette', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, Pallette, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];


    $scope.selectAll = function (select) {
      if (select) {
        $scope.deleted = [];
        for (let i = 0; i < $scope.data.pallettes.data.length; i++) {
          $scope.deleted.push($scope.data.pallettes.data[i].id);
        }
      } else {
        $scope.deleted = [];
      }
    };

    $scope.filterData = {
      station_id: [],
      price: '',
      vehicle: [],
      page: 1,
      date: {
        startDate: null,
        endDate: null
      }
    }

    $scope.clearFilter = function (page) {
      $scope.filterData = {
        station_id: [],
        price: '',
        vehicle: [],
        page: 1,
        date: {
          startDate: null,
          endDate: null
        }
      }
      $scope.all();
    }

    $scope.$on('refresh_data', function () {
      console.log('refreshing map...')
      $scope.all();
    }, true);

    $scope.$on('new_data', function () {
      $scope.pallette = {}
      $scope.new();
      $('#palletteDetail').modal('hide');
      $('#newInvoice').modal('show');
    }, true);

    $scope.editInvoice = function (page) {
      $scope.new();
      $('#palletteDetail').modal('hide');
      $('#newInvoice').modal('show');
    }

    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.all();
    }

    $scope.all = function (type) {
      Pallette.all($scope.filterData).success(function (data, status, headers, config) {
        $scope.data = data;

        if (type && type == 'open') {
          var tempInvoice = $scope.data.pallettes.data.find(function (element) {
            return element.id == $scope.pallette.id;
          })
          $scope.openPaletteDetail(tempInvoice);
        }
      });
    }

    $scope.get = function () {
      Pallette.get($routeParams.id).success(function (data, status, headers, config) {
        $scope.data = data;
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
      });
    }

    $scope.new = function () {
      Pallette.new().success(function (data, status, headers, config) {
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Pallette.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.pallettes.data.indexOf($filter('filter')($scope.data.pallettes.data, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1)
              $scope.data.pallettes.data.splice(index, 1);
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.save = function () {
      if ($scope.pallette.id) {
        $scope.update();
      } else {
        Pallette.save($scope.pallette).success(function (data, status, headers, config) {
          $scope.data = data;
          Messenger().post(data.message);
          $('#newInvoice').modal('hide');
          $scope.all();
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.update = function () {
      Pallette.update($scope.pallette).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post(data.message);
        $('#newInvoice').modal('hide');
        $scope.all('open');

      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };
    $scope.pallette = {
      count: 3,
      pallettes: []
    }
    jQuery('#date').datetimepicker({
      timepicker: false,
      datepicker: true,
      format: 'Y-m-d'
    });

    $scope.showCompletedOrders = function (pallette) {
      if($scope.palletteType == 'pallette') {
        var data = {
          pallette_id: pallette.id,
        }
      }else {
        var data = {
          collection_id: pallette.id,
        }
      }
      var url = 'orders?data=' + JSON.stringify(data);
      window.open(url, '_blank');
    }

    $scope.openPayment = function (payment) {
      $scope.payment = payment;
      jQuery('#payment_date').datetimepicker({
        timepicker: false,
        datepicker: true,
        format: 'Y-m-d'
      });
      $('#palletteDetail').modal('hide');
      $('#newInvoicePayment').modal('show');
    }

    $scope.newPayment = function () {
      $scope.payment = {};
      jQuery('#payment_date').datetimepicker({
        timepicker: false,
        datepicker: true,
        format: 'Y-m-d'
      });
      $('#palletteDetail').modal('hide');
      $('#newInvoicePayment').modal('show');
    }

    $scope.addPayment = function () {
      if ($scope.payment.id) {
        $scope.updatePayment();
      } else {
        $scope.payment.pallette_id = $scope.pallette.id;
        $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
        Pallette.addPayment($scope.payment).success(function (data, status, headers, config) {
          $scope.data = data;
          Messenger().post(data.message);
          $('#newInvoicePayment').modal('hide');
          $scope.all('open');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.updatePayment = function () {
      $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
      Pallette.updatePayment($scope.payment).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post(data.message);
        $('#newInvoicePayment').modal('hide');
        $scope.all('open');
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.deletePayment = function (payment) {
      if (confirm($translate.instant("ARE_U_SURE_DELETE"))) {
        Pallette.deletePayment(payment.id).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          $scope.all('open');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.getPrice = function(payment) {
      try {
        $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
      } catch (error) {
      }
    }

  }
]);